/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_ExternalInputs */

const cs_calendar_external = /** @type {(inputs: Calendar_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externí`)
};

const en_calendar_external = /** @type {(inputs: Calendar_ExternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External`)
};

/**
* | output |
* | --- |
* | "External" |
*
* @param {Calendar_ExternalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_external = /** @type {((inputs?: Calendar_ExternalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_ExternalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_external(inputs)
	return cs_calendar_external(inputs)
});